import initDrawer from "./initDrawer";
import initHeader from "./initHeader";
import initSmoothScroll from "./initSmoothScroll";
import initStickySidebar from "./initStickySidebar";
import initViewport from "./initViewport";
import initSplide from "./initSplide";
import initTabs from "./initTabs";

export default function initCommonScript() {
  // viewport固定
  initViewport();

  // headerコンテンツ
  initHeader();

  // スムーススクロール
  initSmoothScroll();

  // ドロワーメニュー
  initDrawer();

  // 追従サイドバー
  initStickySidebar();

  // スプライド
  initSplide();

  // タブ切り替え
  initTabs();
}
